"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var DECIMAL_REGEX = new RegExp(/[^0-9\\.\\-\\,]/);
var _default = DECIMAL_REGEX;
exports.default = _default;
module.exports = exports.default;